import { WholeNumber_Schema } from "@/utilities";
import { z } from "zod";

export const ParameterValueId_Schema = z.number(); // can be negative!
export type ParameterValueId = z.infer<typeof ParameterValueId_Schema>;

export enum ValueRule {
  CollectiblesOnly = "CollectiblesOnly", // When selected this value, item can be only collectible-based
  AddBackSidePhoto = "AddBackSidePhoto", // When selected this value, allow user to add back side photo
  AiIdentificationAvailable = "AiIdentificationAvailable",
}

export const ItemParameterValue_Schema = z
  .object({
    valueId: ParameterValueId_Schema,
    valueName: z.string(),
    valueExtraRule: WholeNumber_Schema, // In fact, it's a bitfield

    // There is way way more, feel free to define them if needed.
  })
  .transform(({ valueExtraRule, valueId, valueName, ...rest }) => {
    const rules: ValueRule[] = [];
    if (valueExtraRule !== null) {
      if (valueExtraRule & 1) rules.push(ValueRule.CollectiblesOnly); // EXTRA_RULE_COLLECTIBLE_SEARCH
      if (valueExtraRule & 2) rules.push(ValueRule.AddBackSidePhoto); // EXTRA_RULE_SHOW_BACK
      if (valueExtraRule & 4) rules.push(ValueRule.AiIdentificationAvailable); // EXTRA_RULE_USE_AI
    }

    return {
      ...rest,
      id: valueId,
      rules,
      value: valueName,
    };
  });
export type ItemParameterValue = z.infer<typeof ItemParameterValue_Schema>;

export const ParameterElasticId_Schema = z.number(); // can be negative!
export type ParameterElasticId = z.infer<typeof ParameterElasticId_Schema>;

export enum ItemParameterViewType {
  Dropdown = "dropdown",
  Checkboxes = "checkboxes",
  Radios = "radios",
  Slider = "slider",
}

export const ItemParameter_Schema = z
  .object({
    id: ParameterElasticId_Schema,
    name: z.string(),
    viewType: z.enum(ItemParameterViewType).nullable(),
    overridable: z.boolean(),
    allowCustomValues: z.boolean(),
    displayOrder: WholeNumber_Schema,
    values: z.array(ItemParameterValue_Schema),
    required: z.boolean(),
    secondary: z.boolean(),
    conditionParameterId: ParameterElasticId_Schema.nullable(),
    conditionValueId: ParameterValueId_Schema.nullable(),
    // There is way more, we do not use them
  })
  .transform(({ required, secondary, ...rest }) => ({
    ...rest,
    isRequired: required,
    isSecondary: secondary,
  }));

export type ItemParameter = z.infer<typeof ItemParameter_Schema>;

// Used in elastic filter
export const ParameterElastic_Schema = z.object({
  id: ParameterElasticId_Schema,
  name: z.string(),

  valueId: ParameterValueId_Schema,
  value: z.string().nullable(),

  // there are also other properties (valueInt, valueBool, ...), but they are not used
});
export type ParameterElastic = z.infer<typeof ParameterElastic_Schema>;

// This is something between ItemParameter and ItemParameterValue - maybe some refactoring in the future?
export const FilledInParameter_Schema = z
  .object({
    keyId: ParameterElasticId_Schema,
    valueName: z.string(),
    allowCustomValues: z.boolean(),
    valueId: ParameterValueId_Schema.nullable(),

    // There is way more, we do not use them
  })
  .transform(({ keyId, valueName, ...rest }) => ({
    ...rest,
    parameterId: keyId,
    value: valueName,
  }));

export type FilledInParameter = z.infer<typeof FilledInParameter_Schema>;
